<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="ack"><a id="page_5">Acknowledgments</a></h2><a id="page_5">
<p class="indent">Firstly, I’d like to thank Michael and Kirsten and all of Career Press for believing in me and this book.</p>
<p class="indent">I’d like to thank Donn for his help with all things lawyer; everyone who participated in my polls; AshleyGAGA and Rena Havey for their expertise in blogging; Paul and Sandy and the Woman and my father, for being the most supportive parents and in-laws anyone could ask for; and Courtney, George, Tracy, Brenna, Ryan, Zayne, Lissy, and all my other dear friends who wouldn’t let me give up.</p>
<p class="indent">Most of all I want to thank my soul mate and husband, Matt, for being my rock and helping to make our dreams come true.</p>
</a><p class="noindent"><a id="page_5"></a><a id="page_6"></a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?b2d788e6